import { render } from "./NumberInput.vue?vue&type=template&id=6a6583b2"
import script from "./NumberInput.vue?vue&type=script&lang=js"
export * from "./NumberInput.vue?vue&type=script&lang=js"
script.render = render

export default script